import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Blkn from "./sections/Blkn";
import AboutBlkn from "./sections/AboutBlkn";
import GetYourTickets from "./sections/GetYourTickets";
import KeepUpWithUs from "./sections/KeepUpWithUs";
import FollowUs from "./sections/FollowUs";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Blkn />
      <AboutBlkn />
      <GetYourTickets />
      <KeepUpWithUs />
      <FollowUs />
      <SiteFooter />
    </div>;
}